import https from "./https";
import store from "@/store"

const organization = store.state.general.organization;

const flaps = {
  query(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query`, 
      { params }
    );
  },

  queryCoupon(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query-coupon`,
      { params }
    );
  },

  queryRemainderBonus(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query-remainder-bonus`,
      { params }
    );
  },

  queryBonusLog(params) {
    return https.get(
      `admin/organizations/${organization.id}/flaps/query-bonus-log`,
      { params }
    );
  }
};

export default flaps

